import { Pipe, PipeTransform, Inject, LOCALE_ID, Injector } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';



@Pipe({
    name: "FormatDatePipe"
})
export class FormatDatePipe implements PipeTransform {


    constructor(private injector: Injector) {
    }

    public transform(value: string, dateFormat: string, timeFormat: string, fromUTC: boolean = false, toUTC: boolean = false): string {
        try {
            if (value == "" || value == null || value == undefined) {
                return "";
            }

            if (dateFormat != 'isoformat') {
                value = value.replace(/-/g, '/');
            }
            let myMoment: moment.Moment = moment(value);
            return myMoment.format("MM/DD/YYYY")


            //     let date = new Date(value);
            //    alert(date);     
            //     var year = date.getFullYear();

            //     var month = (1 + date.getMonth()).toString();
            //     month = month.length > 1 ? month : '0' + month;

            //     var day = date.getDate().toString();
            //     day = day.length > 1 ? day : '0' + day;

            //     return month + '/' + day + '/' + year;
        }
        catch (ex) {
            return value;
        }


        // let localeDateTimeFormat: string;

        // let culture: string = this.injector.get(LOCALE_ID);

        // if (fromUTC.toString() == "true") {
        //     value = DateTimeHelper.GetIANADateTimeFromUTC(SessionHelper.getUserOtherInfo().IanaTimeZone, value, "YYYY-MM-DDTHH:mm:ss");
        // }
        // else if (toUTC.toString() == "true") {
        //     value = DateTimeHelper.GetUTCDateTimeFromIANA(SessionHelper.getUserOtherInfo().IanaTimeZone, value, "");
        // }

        // // else {
        // //  value=   moment.utc(value).format(localeDateTimeFormat);
        // // }  

        // // Get provided date format.
        // switch (DateStyle[dateFormat]) {
        //     case DateStyle.Long:  
        //         localeDateTimeFormat = DateTimeHelper.GetLongFormattedDate(value);
        //         break;
        //     case DateStyle.Medium:
        //         localeDateTimeFormat = DateTimeHelper.GetMediumFormattedDate(value);
        //         break;
        //     case DateStyle.Short:
        //         localeDateTimeFormat = DateTimeHelper.GetShortFormattedDate(value);
        //         break;
        //     case DateStyle.DayMonth:
        //         localeDateTimeFormat = DateTimeHelper.GetDayMonthFormattedDate(value);
        //         break;
        //     case DateStyle.WeekDayWithTime:
        //         localeDateTimeFormat = DateTimeHelper.GetWeekDayTimeFormat(value);
        //         break;
        //     default:
        //         localeDateTimeFormat = DateTimeHelper.GetMediumFormattedDate(value);
        //         break;
        // }

        // // Get provided time format.
        // if (timeFormat != "") {
        //     if(dateFormat == ""){
        //         localeDateTimeFormat = "";
        //     }
        //     switch (TimeStyle[timeFormat]) {
        //         case TimeStyle.Long:
        //             localeDateTimeFormat += " " + DateTimeHelper.GetLongFormattedTime(value);
        //             break;
        //         case TimeStyle.Short:
        //             localeDateTimeFormat += " " + DateTimeHelper.GetShortFormattedTime(value);
        //             break;
        //         default:
        //             localeDateTimeFormat += " " + DateTimeHelper.GetShortFormattedTime(value);
        //             break;
        //     }
        // }
        // return localeDateTimeFormat;
    }
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/format-date.pipe.ts